<template>
    <div>
        <v-container fluid >
            
            <v-layout grid-list-ld>
                <v-flex >
                <h1>Bienvenido!</h1>
                <div v-if="!showWelcome">
                    <h2 >Actualmente está operando en {{UiCustomUserSettings.canalVentaPredeterminado}} de {{ UiCustomUserSettings.empresaPredeterminada}}</h2>
                    <v-row>
                        <v-col v-if="mostrarTareasFrecuentes">
                            <tareas-frecuentes ></tareas-frecuentes>
                        </v-col>
                        <v-col v-if="mostrarRecordatorios" cols="4">
                            <recordatorios ></recordatorios>
                        </v-col>
                        
                    </v-row>
<!--                     
                    <v-layout grid-list-ld row fluid >
                        <v-flex xs8 v-if="mostrarTareasFrecuentes">
                            <tareas-frecuentes ></tareas-frecuentes>
                        </v-flex>
                        <v-flex xs4 v-if="mostrarRecordatorios">
                            <recordatorios ></recordatorios>
                        </v-flex>                        
                    </v-layout> -->

                </div>
                <div v-else>
                    <h2 >Este es su primer ingreso al sistema, por lo que necesitamos configurar unas cosas: </h2>
                    <h2 >&nbsp;</h2>
                    <v-chip multi-line class="headline font-weight-black" color="green" dark > 
                        Como primer paso, haga click aquí &nbsp; 
                        <app-user-customization ></app-user-customization>, 
                        para definir la Empresa y Canal de Venta en la que trabajará</v-chip>
                </div>
                </v-flex>
            </v-layout>
            
        </v-container>
    </div>
</template>

<script>
import Vue from 'vue'
import TareasFrecuentes from '../components/TareasFrecuentes'
import Recordatorios from '../components/Recordatorios'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export 
    default {
     components:{    
        'tareas-frecuentes': TareasFrecuentes,
        'recordatorios': Recordatorios
    },
    computed:{
        ...mapGetters(['UiCustomUserSettings', 'user', 'DebugModeOn']),
        mostrarTareasFrecuentes () {
            return this.$store.getters.UiCustomUserSettings.mostrarTareasFrecuentes;
        },
        mostrarRecordatorios () {
            return this.$store.getters.UiCustomUserSettings.mostrarRecordatorios;
        },        
        showWelcome (){
            return (this.UiCustomUserSettings.canalVentaPredeterminadoId ==0);
        },
    },
    methods: {       
    }
    };
</script>